
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function useExpertUnpublisher(onRefresh: () => void) {
  const handleUnpublishExpert = async (applicationId: string) => {
    if (!confirm("Are you sure you want to unpublish this expert? They will no longer be visible to clients.")) {
      return;
    }

    try {
      console.log(`🔄 Unpublishing expert for application ${applicationId}...`);
      
      const { error } = await supabase
        .from("consultation_experts")
        .update({ status: 'inactive' })
        .eq("application_id", applicationId);

      if (error) throw error;

      console.log("✅ Expert unpublished successfully");
      toast.success("Expert unpublished successfully");
      onRefresh();
    } catch (error) {
      console.error("💥 Error unpublishing expert:", error);
      toast.error("Failed to unpublish expert");
    }
  };

  return { handleUnpublishExpert };
}
